import axios from 'axios';
import { NikeCasinoApi } from '../../types/generated/nike-casino-api';
import { NikeAccount } from '../../types/generated/nike-account';
import { useQuery } from '@tanstack/react-query';

export const getCasinoGameUrl = (playModeForFun: boolean, gameId: string) => {
    return axios.get<never, NikeCasinoApi.GameUrlResp>(`/api/v2/casino/game-url/${gameId}`, {
        params: { playModeForFun: playModeForFun }
    });
};

export const getCasinoOverlayDepositMethods = () => {
    return axios.get<never, NikeAccount.DepositMethod[]>('/api/payments/deposit/methods-overlay');
};

export const useCasinoGameDescription = (gameId: string) => {
    return useQuery(
        ['casino-game-description', gameId],
        () => axios.get<never, NikeCasinoApi.GameDescriptionDto>(`/api/v2/casino/game-description/${gameId}`),
        {
            staleTime: 5 * 60 * 1000,
            cacheTime: 5 * 60 * 1000
        }
    );
};

export const useCasinoTournamentCarousel = () => {
    return useQuery(
        ['casino-carousel'],
        () => axios.get<never, NikeCasinoApi.CarouselLeaderboardsRespDto>('/api/casino/v2/carousel'),
        { refetchInterval: 5 * 60 * 1000, staleTime: 5 * 60 * 1000 }
    );
};

export const fetchGamebook = (attributes: any, signal?: AbortSignal, fetchAnnotation?: boolean) => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    signal?.addEventListener('abort', () => {
        source.cancel('Query was cancelled by TanStack Query');
    });

    return axios.post<never, NikeCasinoApi.FilteredGamebookResp>(
        '/api/casino/gamebook-filter',
        {
            attributes,
            fetchAnnotation
        },
        { cancelToken: source.token }
    );
};

export const fetchJackpots = () => axios.get<never, NikeCasinoApi.Jackpot[]>('/api/casino/jackpots-new');
